// Public access: any name is accepted.
// During private beta, this used a hardcoded allow-list. Now disabled.
export function isAllowedName(_name: string): boolean {
  return true;
}

export const ACCESS_DENIED_MESSAGE = "";
